export default __webpack_public_path__ + "assets/images/solutions/fa49d52d9d66e4a0fce23a06ebdd72e7.mp4";